if (!customElements.get('mood-addons')) {
  customElements.define(
    'mood-addons',
    class MoodAddons extends HTMLElement {
      constructor() {
        super();

        this.items = this.querySelectorAll('[data-mood-item]');
        this.checkboxes = this.querySelectorAll('[data-mood-checkbox]:not([disabled])');
        this.submitButton = this.querySelector('[data-mood-submit]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.spinner = this.submitButton.querySelector('.loading__spinner');
        this.moneyFormat = this.dataset.moneyFormat;

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.onVariantChange = this.onVariantChange.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
      }

      connectedCallback() {
        this.querySelectorAll('[data-mood-variant-select]').forEach((select) => {
          select.addEventListener('change', this.onVariantChange);
        });

        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', this.onCheckboxChange);
        });

        this.submitButton.addEventListener('click', this.onSubmitHandler);

        this.updateSubmitState();
      }

      disconnectedCallback() {
        this.querySelectorAll('[data-mood-variant-select]').forEach((select) => {
          select.removeEventListener('change', this.onVariantChange);
        });

        this.checkboxes.forEach((checkbox) => {
          checkbox.removeEventListener('change', this.onCheckboxChange);
        });

        this.submitButton.removeEventListener('click', this.onSubmitHandler);
      }

      onCheckboxChange() {
        this.updateSubmitState();
      }

      // Disable Add to Cart unless at least one non-default (togglable) addon is checked
      updateSubmitState() {
        const hasSelectedAddon = Array.from(this.checkboxes).some((checkbox) => checkbox.checked);

        if (hasSelectedAddon) {
          this.submitButton.removeAttribute('aria-disabled');
        } else {
          this.submitButton.setAttribute('aria-disabled', 'true');
        }
      }

      onVariantChange(event) {
        const select = event.currentTarget;
        const option = select.options[select.selectedIndex];
        const price = parseInt(option.dataset.price, 10);
        const compare = parseInt(option.dataset.compare, 10) || 0;
        const priceEl = select.closest('[data-mood-info]').querySelector('[data-mood-price]');

        if (compare > price) {
          priceEl.innerHTML = `<span class="mood-addons__sale">${this.formatMoney(
            price
          )}</span> <s class="mood-addons__compare">${this.formatMoney(compare)}</s>`;
        } else {
          priceEl.textContent = this.formatMoney(price);
        }
      }

      formatMoney(cents) {
        return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
      }

      getSelectedItems() {
        const items = [];

        this.items.forEach((item) => {
          const checkbox = item.querySelector('[data-mood-checkbox]');
          if (!checkbox.checked) return;

          const select = item.querySelector('[data-mood-variant-select]');
          const variantId = select ? select.value : item.dataset.defaultVariantId;

          items.push({ id: parseInt(variantId, 10), quantity: 1 });
        });

        return items;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const items = this.getSelectedItems();
        if (items.length === 0) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        items.forEach((item, index) => {
          formData.append(`items[${index}][id]`, item.id);
          formData.append(`items[${index}][quantity]`, item.quantity);
        });

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'mood-addons',
                productVariantId: items[0]?.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('mood-addons:wait-for-subscribers');
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'mood-addons',
              productVariantId: items[0]?.id,
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker('mood-addons:wait-for-subscribers', startMarker);
            });

            CartPerformance.measure('mood-addons:paint-updated-sections', () => {
              this.cart.renderContents(response);
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.getSelectedItems().length > 0) this.submitButton.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');

            CartPerformance.measureFromEvent('mood-addons:user-action', evt);
          });
      }
    }
  );
}